/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useState } from 'react';
import { FlatList, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, MD2Colors, RadioButton, Snackbar, Text } from 'react-native-paper';
import Modal from 'react-native-modal';
import { modalConatiner, modalHeader, theme } from '../../theme/theme';

const wrapperStyle = { position: 'absolute', bottom: 10, zIndex: 999 };

function CashCounterPaymentMethodsModal({ visible, amount, payment_methods, onCCPaymentMethodSelect, onCCPaymentMethodModalClose }) {
    const [showSnackBar, setShowSnackBar] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const onDismissSnackBar = () => setShowSnackBar(false);

    useEffect(() => {
        if (visible) {
            setSelectedValue(null);
        }
    }, [visible]);

    const renderItem = ({ item }) => {
        return (
            <RadioButton.Item labelStyle={{ fontSize: 12 }} style={{ paddingVertical: 2 }} label={item.cc_pm_name} value={item.cc_pm_id} />
        );
    };

    const onValueChange = (value) => {
        setSelectedValue(value);
    };

    const onSubmit = () => {
        const selectedItem = payment_methods.find(item => item.cc_pm_id === selectedValue);
        if (!selectedItem) {
            setShowSnackBar(true);
        } else {
            onCCPaymentMethodSelect?.(selectedItem);
        }
    };

    return (
        <Modal
            animationOutTiming={500}
            animationInTiming={500}
            coverScreen={true}
            backdropTransitionOutTiming={500}
            hideModalContentWhileAnimating={true}
            isVisible={visible}
            onBackButtonPress={onCCPaymentMethodModalClose}
            onBackdropPress={onCCPaymentMethodModalClose}
            style={modalConatiner}>
            <SafeAreaView style={styles.modalView}>
                <View style={[modalHeader, { paddingVertical: 12, backgroundColor: theme.colors.primary }]}>
                    <Text variant="titleMedium" style={{ color: theme.colors.onPrimary }}>Select Payment Method</Text>
                </View>
                <Divider />
                <RadioButton.Group onValueChange={onValueChange} value={selectedValue}>
                    <FlatList
                        data={payment_methods}
                        renderItem={renderItem}
                        keyExtractor={(item) => (item?.cc_pm_id).toString()}
                    />
                </RadioButton.Group>
                <Divider />
                <View style={{ flexDirection: 'row', justifyContent: 'flex-end', padding: 8 }}>
                    <Button
                        onPress={onCCPaymentMethodModalClose}
                        style={{ marginHorizontal: 8, borderRadius: 4, backgroundColor: MD2Colors.red400 }}
                        labelStyle={{ fontSize: 12 }}
                        mode="contained">
                        Close
                    </Button>
                    <Button
                        onPress={onSubmit}
                        style={{ marginHorizontal: 8, borderRadius: 4 }}
                        labelStyle={{ fontSize: 12 }}
                        mode="contained">
                        Submit
                    </Button>
                </View>
                <Snackbar wrapperStyle={wrapperStyle} duration={2000} visible={showSnackBar} onDismiss={onDismissSnackBar}>
                    Please Select Payment method
                </Snackbar>
            </SafeAreaView>
        </Modal>
    );
}

const styles = StyleSheet.create({
    modalView: {
        // flexGrow: 1,
        minHeight: '20%',
        backgroundColor: '#ffffff',
        borderRadius: 16,
    },
    checkBoxItem: {
        paddingVertical: 2,
    },
    checkBoxItemLabel: {
        fontSize: 12,
    },
});

export default CashCounterPaymentMethodsModal;
